var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.table.headers,"hide-default-footer":"","items":_vm.table.suppliers,"loading":_vm.table.loading,"loading-text":"Buscando proveedores...","no-data-text":"No se encontraron proveedores"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }